export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function toNANPDigits10(value) {
  const digits = digitsOnly(value);
  if (digits.length === 11 && digits.startsWith("1")) {
    return digits.slice(1);
  }
  return digits;
}

export function isValidNANP(digits10) {
  return String(digits10 || "").length === 10;
}

export function formatNANP(value) {
  const raw = value == null ? "" : String(value);
  const digits = digitsOnly(raw);
  if (digits.length !== 10) {
    return digits || raw;
  }
  return `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
}
